import axios from "axios";
import { API_URL } from "../config";
import { user } from "./actions_helper";
import {
    CALENDAR_EVENTS_LOADING_START,
    CREATE_TIME_TRACKING,
    DELETE_TIME_TRACKING,
    GET_TIME_TRACKING,
    UPDATE_TIME_TRACKING,
} from "./types";
import moment from "moment/moment";

export function deleteTimeTracking(id: any) {
    return (dispatch: IDispatch<IReduxAction<any>>) =>
        axios
            .delete(`${API_URL}/timetrackings/${id}.json`, {
                headers: { authorization: user().token },
            })
            .then((response) => {
                dispatch({
                    payload: response.data,
                    type: DELETE_TIME_TRACKING,
                });
            })
            .catch((err) => console.error(err));
}

const toRangeParam = (date: any) => encodeURIComponent(new Date(date).toISOString());

export function getTimeTrackings(employeeId, range, view) {
    return (dispatch: IDispatch<any>) => {
        dispatch({ type: CALENDAR_EVENTS_LOADING_START });
        axios
            .get(
                `${API_URL}/timetrackings.json?view=${view}&employee=${employeeId}&start=${toRangeParam(
                    range.start
                )}&end=${toRangeParam(range.end)}`,
                {
                    headers: { authorization: user().token },
                }
            )
            .then((response) => {
                dispatch({
                    type: GET_TIME_TRACKING,
                    payload: response.data,
                });
            });
    };
}

export function createTimeTracking(timeTracking) {
    return (dispatch: IDispatch<IReduxAction<any>>) =>
        axios
            .post(`${API_URL}/timetrackings.json`, timeTracking, {
                headers: { authorization: user().token },
            })
            .then((response) => {
                dispatch({
                    payload: response.data,
                    type: CREATE_TIME_TRACKING,
                });
            })
            .catch((err) => console.error(err));
}

export function updateTimeTracking(timeTracking) {
    return (dispatch: IDispatch<IReduxAction<any>>) =>
        axios
            .put(`${API_URL}/timetrackings/${timeTracking.id}.json`, timeTracking, {
                headers: { authorization: user().token },
            })
            .then((response) => {
                dispatch({
                    payload: response.data,
                    type: UPDATE_TIME_TRACKING,
                });
            })
            .catch((err) => console.error(err));
}

// Opens an authenticated binary response (e.g. a PDF) in a new tab without
// tripping popup blockers: opens a blank tab synchronously, then points it at
// the fetched blob once it resolves. Used for the timetracking PDF endpoints,
// which now require auth (no session token allowed in the URL) and so can't be
// reached by a plain header-less window.open.
async function openAuthedBlob(url: string) {
    const win = window.open("", "_blank");
    try {
        const response = await axios.get(url, {
            headers: { authorization: user().token },
            responseType: "blob",
        });
        const objectUrl = window.URL.createObjectURL(response.data);
        if (win) {
            win.location.href = objectUrl;
        } else {
            window.location.href = objectUrl;
        }
    } catch (err) {
        if (win) {
            win.close();
        }
        console.error(err);
    }
}

// Opens a per-employee timetracking PDF.
export function openEmployeeTimetrackingPdf(id: any, view: any, start: any, end: any) {
    return async () =>
        openAuthedBlob(
            `${API_URL}/employees/${id}/timetracking.pdf?view=${view}&start=${toRangeParam(
                start
            )}&end=${toRangeParam(end)}`
        );
}

// Opens the all-employees timetracking PDF.
export function openAllTimetrackingsPdf() {
    return async () => openAuthedBlob(`${API_URL}/employees/timetracking.pdf`);
}

export function createPdf(id: any) {
    return async (dispatch: IDispatch<any>) => {
        const response = await axios
            .get(`${API_URL}/timetrackings/pdf?employee=${id}.json`, {
                headers: {
                    authorization: user().token,
                },
                responseType: "blob",
            })
            .then((response) => response.data)
            .then((blob) => {
                const data = window.URL.createObjectURL(blob);
                window.location.href = data;
            })
            .catch((err) => console.error(err));
    };
}
